<div class="wrap">
    <div  *ngIf="isLoading" class="load-spinner"><mat-spinner mode="indeterminate" [diameter]="100" color="primary"></mat-spinner></div>
    <div class="iframe-container"><iframe (load)="isLoading = false" *ngIf="!isLoading" frameBorder="0" [src]="cryptedUrl | safe"></iframe></div>
</div>